import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { grades } from "@api/courses/exams/fileBased/grades/path";
import { attempt } from "@api/courses/exams/fileBased/attempts/path";

const pathBase = `/courses/:courseId/exams/file-based`;
const pathById = `${pathBase}/:examId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const fileBased = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  grades,
  attempt,
} as const;
